export enum NotificationBarActionTypes {
	SET_AUTH_ERROR = '@@notificationbar/SET_AUTH_ERROR',
	SET_ERROR = '@@notificationbar/SET_ERROR',
	SET_INFO_MESSAGE = '@@notificationbar/SET_INFO_MESSAGE',
	SET_SUCCESS_MESSAGE = '@@notificationbar/SET_SUCCESS_MESSAGE',
}

export interface INotificationBarState {
	autherror: Error | null;
	error: Error | null;
	infoMessage: string | null;
	successMessage: string | null;
}
